/**
 * @generated SignedSource<<e726e335ce84334e3d045619379f9523>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ForgotPasswordInput = {
  brandId: string;
  clientMutationId?: string | null;
  email: string;
};
export type ForgotPasswordScreen_ForgotPasswordMutation$variables = {
  input: ForgotPasswordInput;
};
export type ForgotPasswordScreen_ForgotPasswordMutation$data = {
  readonly InfectopharmAuth: {
    readonly forgotPassword: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type ForgotPasswordScreen_ForgotPasswordMutation = {
  response: ForgotPasswordScreen_ForgotPasswordMutation$data;
  variables: ForgotPasswordScreen_ForgotPasswordMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "InfectopharmAuthMutations",
    "kind": "LinkedField",
    "name": "InfectopharmAuth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "ForgotPasswordPayload",
        "kind": "LinkedField",
        "name": "forgotPassword",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ForgotPasswordScreen_ForgotPasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ForgotPasswordScreen_ForgotPasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "25cc455bd8637793460bcbf7f187bc9e",
    "id": null,
    "metadata": {},
    "name": "ForgotPasswordScreen_ForgotPasswordMutation",
    "operationKind": "mutation",
    "text": "mutation ForgotPasswordScreen_ForgotPasswordMutation(\n  $input: ForgotPasswordInput!\n) {\n  InfectopharmAuth {\n    forgotPassword(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "45140c7fdcfdf1ea7050710dc470933d";

export default node;
